













































import {
  Vue,
  Component,
} from "@/shared/vuepack";

import { Validator } from "vee-validate";
import DisclosureLinks from "@/employee/components/investments/drivewealth/DisclosureLinks.vue";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { DocumentSaveSignatureRequest, DrivewealthWizardStep, LeafHouseDisclosureDocumentKey } from "@/shared/types";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { BankCustodian } from "@/admin/types";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useUserStore } from "@/shared/store/user";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component ({
  computed: {
    LeafHouseDisclosureDocumentKey () {
      return LeafHouseDisclosureDocumentKey;
    }
  },
  components: {
    DisclosureLinks,
    WizardNavigation,
  }
})
export default class TermsAndConditions extends Vue {
  $validator: Validator;
  userStore = useUserStore();
  drivewealthWizard = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  custodianSettingsStore = useCustodianSettingsStore();
  signingDocumentStore = useSigningDocumentStore();

  tryAdvance () {
    this.$validator
      .validate()
      .then(isValid => {
        if (isValid) {
          this.drivewealthWizard.setWizardStepComplete(DrivewealthWizardStep.TermsAndConditions);
        }
      });
  }

  get didAgreeToTerms () {
    return this.drivewealthWizard.termsDidAgree;
  }

  set didAgreeToTerms (value: boolean) {
    this.drivewealthWizard.setTermsDidAgree(value);
  }

  get wizardStep () {
    return DrivewealthWizardStep.TermsAndConditions;
  }

  get isHsab () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
